module.exports = __webpack_public_path__ + "img/logo.5a7e3c69.png";